import styled from 'styled-components';

import { fadeIn } from '../../styles/shared.style';

/* "Entenda as taxas" modal (Figma 16501-33810). */

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  /*
   * int32 max, same as the third-party cookie banner: with a lower z-index the
   * banner covered "Entendi" on short screens. Ties are won by DOM order, so
   * the modal is appended to the end of body on open, after the banner.
   */
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  /* Scrolling over the overlay/dialog does not chain to the page (iOS). */
  overscroll-behavior: contain;
  background-color: rgba(10, 10, 10, 0.7);
  backdrop-filter: blur(8px);
  animation: ${fadeIn} 0.2s ease-out;
`;

export const Dialog = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 24px;
  border-radius: 16px;
  background-color: #FFFFFF;
  box-shadow: 0 20px 24px -4px rgba(10, 13, 18, 0.08), 0 8px 8px -4px rgba(10, 13, 18, 0.03);

  &:focus {
    outline: none;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #171717;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: -8px -8px 0 0;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #737373;
  cursor: pointer;

  /* Drop the button:hover background from globalStyles. */
  &:hover {
    background: transparent;
    color: #404040;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accent.primary};
    outline-offset: 2px;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Item = styled.p`
  margin: 0;
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #525252;
`;

/* Desktop: name on its own line. Mobile (prototype): name and text run inline. */
export const ItemName = styled.strong`
  display: block;
  font-weight: 600;

  ${({ theme }) => theme.media.mobile} {
    display: inline;
  }
`;

export const ConfirmButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.button.surface.primary};
  color: ${({ theme }) => theme.colors.button.text.primary};
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.button.hover.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.button.surface.primary};
    outline-offset: 2px;
  }
`;
